import { useSyncExternalStore } from "react";

const toggledOnByScope = new Map<string, boolean>();
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

/** Updates every mounted Rules switch for this workspace user at once; the caller persists the value. */
export const setRulesSuggestionToggledOn = ({
    scopeKey,
    isOn,
}: {
    scopeKey: string;
    isOn: boolean;
}) => {
    toggledOnByScope.set(scopeKey, isOn);
    listeners.forEach((listener) => listener());
};

export const useRulesSuggestionToggledOn = ({
    scopeKey,
    cachedValue,
}: {
    scopeKey: string;
    cachedValue: boolean | undefined;
}): boolean =>
    useSyncExternalStore(
        subscribe,
        () => toggledOnByScope.get(scopeKey) ?? cachedValue ?? false,
        () => false,
    );
